if (!customElements.get('kiive-feature-explorer')) {
  customElements.define('kiive-feature-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.tabs = Array.from(this.querySelectorAll('[data-kve-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-kve-panel]'));
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index), {signal});
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        }, {signal});
      });
      this.panels.forEach(panel => {
        panel.querySelectorAll('[data-kve-side]').forEach(button => button.addEventListener('click', () => this.side(panel, button.dataset.kveSide), {signal}));
        this.side(panel, 'n');
      });
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.kvePanel === event.detail.blockId);
        if (index < 0) return;
        this.select(index);
        this.scrollIntoView({block:'center', behavior:'auto'});
      }, {signal});
      this.select(0);
      this.setAttribute('data-ready', '');
    }
    select(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
    }
    side(panel, side) {
      panel.querySelectorAll('[data-kve-side]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.kveSide === side)));
      panel.querySelectorAll('[data-kve-copy]').forEach(copy => { copy.hidden = copy.dataset.kveCopy !== side; });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
